<script setup lang="ts">
import type { Component } from 'vue'
import ElementalItemButton from '../ElementalItemButton/index.vue'
import type { Elemental } from '~~/src/types/elemental'
import { ElementalTypeEnum } from '~~/src/types/elemental'
import { cn } from '~~/src/utils'

const props = defineProps<{
  content: string
  elemental: Elemental
  is?: Component
  iconClass?: HTMLElement['className']
}>()

const { isSupported, copied, copy } = useClipboard({ copiedDuring: 700 })

const copyToClipboard = () => {
  copy(props.content.replace('#', ''))
}

const showCopy = computed(() => {
  return isSupported && props.elemental.elementalTypeId !== ElementalTypeEnum.Automation
})
</script>

<template>
  <component :is="is ?? ElementalItemButton" v-if="showCopy" :disable="!isSupported" :title="copied ? 'Copied to clipboard' : 'Copy to clipboard'" @click="copyToClipboard">
    <div v-if="!copied" i-material-symbols:content-copy-outline :class="cn(iconClass)" />
    <div v-else i-material-symbols:done :class="cn(iconClass)" />
  </component>
</template>
